import { useSelector } from "react-redux";

import type { TaskType, UUID } from "@/core/types";
import type { RootState } from "@/lib/types/state";
import { selectTaskIdByType } from "@/redux/selectors/authSelectors";

export function useTaskIdByType(taskType: TaskType): undefined | UUID {
  return useSelector((state: RootState) => selectTaskIdByType(state, taskType));
}
